export default __webpack_public_path__ + "static/media/2017 LV CATALOGUE-01.e827b6a2.jpg";